jQuery( document ).ready(function( $ ) {
  $('.tyler-slider').slick({
  infinite: true,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1
});

$('.ensembles-slider').slick({
  infinite: true,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots:false
      }
    },
{
breakpoint:426,
settings:{
slidesToShow:1,
slidesToScroll:1,
infinite:true,
dots:false
}
}
]
});
});